// leaf-town - level runtime: tiles, collision, camera, particles, projectiles, pickups
(function () {
  'use strict';
  const G = window.G, T = 16, W = G.W, H = G.H, S = G.SPR, C = G.COL;
  const E = 0, SOLID = 1, ONEWAY = 2, SPIKE_U = 3, SPIKE_D = 4, CRACK = 5, CRUMBLE = 6, BLINK_A = 7, BLINK_B = 8, LIQ = 9;
  G.TILE = { E, SOLID, ONEWAY, SPIKE_U, SPIKE_D, CRACK, CRUMBLE, BLINK_A, BLINK_B, LIQ };
  const TILECHAR = { '#': SOLID, '=': ONEWAY, '^': SPIKE_U, v: SPIKE_D, '%': CRACK, '~': CRUMBLE, 1: BLINK_A, 2: BLINK_B, w: LIQ };

  class Level {
    constructor(def, snap) {
      this.def = def; this.id = def.id; this.world = def.world; this.th = G.THEME[def.world];
      const rows = def.map;
      this.h = rows.length; this.w = rows.reduce((m, r) => Math.max(m, r.length), 0);
      this.pw = this.w * T; this.ph = this.h * T;
      this.tiles = new Uint8Array(this.w * this.h);
      this.ents = []; this.items = []; this.plats = []; this.projs = []; this.fx = []; this.signs = []; this.cps = []; this.springs = []; this.zones = [];
      this.exit = null; this.boss = null; this.bossSpawn = null;
      this.time = 0; this.clock = 0; this.hitstop = 0; this.trauma = 0; this.flash = 0; this.flashCol = '#fff';
      this.breakQ = [];
      this.crumble = new Map(); this.blinkHold = new Set(); this.blinkPhase = 0; this.blinkPeriod = def.blink || 1.5;
      this.tokens = 0; this.tokTotal = 0; this.got = new Set(snap ? snap.got : []); this.kills = 0; this.hits = 0;
      this.sparks = snap ? snap.sparks.slice() : [false, false, false];
      this.cam = { x: 0, y: 0, ty: 0, look: 0, lock: null };
      this.events = [];
      this.liquidY = null; this.rise = def.rise || null; this.rising = false;
      let start = { x: 32, y: 32 }, signN = 0, itemId = 0;
      const sparkSpots = [];
      for (let ty = 0; ty < this.h; ty++) {
        const row = rows[ty];
        for (let tx = 0; tx < row.length; tx++) {
          const ch = row[tx], x = tx * T, y = ty * T;
          if (TILECHAR[ch]) { this.tiles[ty * this.w + tx] = TILECHAR[ch]; continue; }
          switch (ch) {
            case ' ': case '.': case '|': break;
            case 'P': start = { x: x + 3, y: y + 6 }; break;
            case 'C': this.cps.push({ x: x + 8, y: y + T, on: false }); break;
            case 'E': this.exit = { x: x + 8, y: y + T, t: 0 }; break;
            case 'S': this.springs.push({ x: x + 2, y: y + 9, w: 12, h: 7, t: 0 }); break;
            case 'o': { const id = itemId++; this.tokTotal++; if (!this.got.has(id)) this.items.push({ kind: 'token', x: x + 8, y: y + 8, id, ph: tx * 0.7 }); break; }
            case '*': sparkSpots.push({ x: x + 8, y: y + 8 }); break;
            case 'H': { const id = itemId++; if (!this.got.has(id)) this.items.push({ kind: 'coffee', x: x + 8, y: y + 9, id, ph: 0 }); break; }
            case 'T': this.signs.push({ x: x + 8, y: y + T, text: (def.signs || [])[signN++] || '...' }); break;
            case 'B': this.bossSpawn = { x: x + 8, y: y + T }; break;
            case 'M': case 'V': {
              let a = ch === 'M' ? x : y, b = a;
              if (ch === 'M') {
                for (let i = tx + 1; i < row.length; i++) if (row[i] === '|') { b = (i + 1) * T - 48; break; }
                if (b === a) for (let i = tx - 1; i >= 0; i--) if (row[i] === '|') { b = i * T; break; }
              } else {
                for (let j = ty + 1; j < this.h; j++) if (rows[j][tx] === '|') { b = j * T; break; }
                if (b === a) for (let j = ty - 1; j >= 0; j--) if (rows[j][tx] === '|') { b = j * T; break; }
              }
              this.plats.push({ x, y: y + 2, w: 48, h: 6, ax: ch === 'M', a, b, ph: (tx * 0.37 + ty * 0.61) % 1, dx: 0, dy: 0, speed: def.platSpeed || 44 });
              break;
            }
            default:
              if (G.spawnEnemy) { const e = G.spawnEnemy(ch, x, y, this); if (e) this.ents.push(e); }
          }
        }
      }
      sparkSpots.sort((a, b) => a.x - b.x || a.y - b.y);
      sparkSpots.forEach((s, i) => { if (i < 3) this.items.push({ kind: 'spark', x: s.x, y: s.y, idx: i, ph: i, ghost: this.sparks[i] || !!(G.save.data.sparks[this.id] || [])[i] }); });
      if (snap) { this.tokens = snap.tokens; this.clock = snap.clock; this.kills = snap.kills; this.hits = snap.hits; }
      if (snap && snap.cp >= 0 && this.cps[snap.cp]) {
        const cp = this.cps[snap.cp];
        cp.on = true; this.cpIndex = snap.cp; start = { x: cp.x - 5, y: cp.y - 10 };
      } else this.cpIndex = -1;
      this.renderStatic();
      this.player = new G.Player(this, start.x, start.y);
      if (def.boss && G.Bosses && G.Bosses[def.boss]) {
        const bs = this.bossSpawn || { x: this.pw - 80, y: this.ph - 48 };
        this.boss = new G.Bosses[def.boss](this, bs.x, bs.y);
        this.ents.push(this.boss);
      }
      if (this.rise) this.liquidY = this.ph + 30;
      this.snapCam();
    }
    snapshot() { return { cp: this.cpIndex, tokens: this.tokens, got: Array.from(this.got), sparks: this.sparks.slice(), clock: this.clock, kills: this.kills, hits: this.hits }; }

    // ---------- tiles ----------
    tile(tx, ty) {
      if (tx < 0 || tx >= this.w || ty < 0) return SOLID;
      if (ty >= this.h) return E;
      return this.tiles[ty * this.w + tx];
    }
    solid(tx, ty) {
      const t = this.tile(tx, ty);
      if (t === SOLID || t === CRACK) return true;
      if (t < CRUMBLE || t === LIQ) return false;
      const i = ty * this.w + tx;
      if (t === CRUMBLE) { const c = this.crumble.get(i); return !c || c.s !== 2; }
      if (this.blinkHold.has(i)) return false;
      return t === BLINK_A ? this.blinkPhase === 0 : this.blinkPhase === 1;
    }
    solidAt(px, py) { return this.solid(Math.floor(px / T), Math.floor(py / T)); }
    boxHitsSolid(x, y, w, h) {
      const x0 = Math.floor(x / T), x1 = Math.floor((x + w - 0.001) / T), y0 = Math.floor(y / T), y1 = Math.floor((y + h - 0.001) / T);
      for (let ty = y0; ty <= y1; ty++) for (let tx = x0; tx <= x1; tx++) if (this.solid(tx, ty)) return true;
      return false;
    }
    moveX(e, dx) {
      e.x += dx;
      if (!dx) return 0;
      const y0 = Math.floor(e.y / T), y1 = Math.floor((e.y + e.h - 0.001) / T);
      if (dx > 0) {
        const tx = Math.floor((e.x + e.w - 0.001) / T);
        for (let ty = y0; ty <= y1; ty++) if (this.solid(tx, ty)) { e.x = tx * T - e.w; return 1; }
      } else {
        const tx = Math.floor(e.x / T);
        for (let ty = y0; ty <= y1; ty++) if (this.solid(tx, ty)) { e.x = (tx + 1) * T; return -1; }
      }
      return 0;
    }
    moveY(e, dy, noOneway) {
      const prevBottom = e.y + e.h;
      e.y += dy;
      if (!dy) return 0;
      const x0 = Math.floor(e.x / T), x1 = Math.floor((e.x + e.w - 0.001) / T);
      if (dy > 0) {
        const ty = Math.floor((e.y + e.h - 0.001) / T);
        for (let tx = x0; tx <= x1; tx++) {
          if (this.solid(tx, ty) || (!noOneway && this.tile(tx, ty) === ONEWAY && prevBottom <= ty * T + 0.01)) { e.y = ty * T - e.h; return 1; }
        }
      } else {
        const ty = Math.floor(e.y / T);
        for (let tx = x0; tx <= x1; tx++) if (this.solid(tx, ty)) { e.y = (ty + 1) * T; return -1; }
      }
      return 0;
    }
    // is there floor right under this box?
    grounded(e) {
      const ty = Math.floor((e.y + e.h + 1) / T), x0 = Math.floor(e.x / T), x1 = Math.floor((e.x + e.w - 0.001) / T);
      for (let tx = x0; tx <= x1; tx++) { const t = this.tile(tx, ty); if (this.solid(tx, ty) || (t === ONEWAY && e.y + e.h <= ty * T + 0.5)) return true; }
      return false;
    }
    platUnder(e, prevBottom) {
      for (const p of this.plats) {
        if (e.x + e.w > p.x && e.x < p.x + p.w && prevBottom <= p.y + 2 + Math.abs(p.dy) && e.y + e.h >= p.y) return p;
      }
      return null;
    }
    breakTile(tx, ty) {
      if (this.tile(tx, ty) !== CRACK) return false;
      this.tiles[ty * this.w + tx] = E;
      this.burst(tx * T + 8, ty * T + 8, 12, ['#8d8798', '#c3bccd', '#4c4658'], 90, 300);
      this.shake(0.3); G.audio.sfx('brk');
      // the rest of the wall follows a moment later
      for (const [ox, oy] of [[1, 0], [-1, 0], [0, 1], [0, -1]]) if (this.tile(tx + ox, ty + oy) === CRACK) this.breakQ.push({ tx: tx + ox, ty: ty + oy, t: 0.06 });
      return true;
    }
    // nearest dry place to stand (used when the last safe spot is gone)
    findSafe(x, y) {
      let best = null, bd = 1e9;
      for (let ty = 1; ty < this.h; ty++) for (let tx = 1; tx < this.w - 1; tx++) {
        const t = this.tiles[ty * this.w + tx];
        if ((t !== SOLID && t !== ONEWAY) || this.tiles[(ty - 1) * this.w + tx] !== E) continue;
        if (this.liquidY !== null && ty * T > this.liquidY - 12) continue;
        const d = Math.abs(tx * T + 8 - x) + Math.abs(ty * T - y) * 1.5;
        if (d < bd) { bd = d; best = { x: tx * T + 3, y: ty * T - 10 }; }
      }
      return best;
    }
    renderStatic() {
      const L = (this.layer = G.makeCanvas(this.pw, this.ph)), g = L.g, w = this.world;
      const isS = (tx, ty) => { const t = this.tile(tx, ty); return t === SOLID; };
      for (let ty = 0; ty < this.h; ty++) for (let tx = 0; tx < this.w; tx++) {
        const t = this.tiles[ty * this.w + tx], px = tx * T, py = ty * T;
        if (t === SOLID) {
          G.drawSolid(g, w, px, py, tx, ty, { u: isS(tx, ty - 1) || ty === 0, d: isS(tx, ty + 1) || ty === this.h - 1, l: isS(tx - 1, ty), r: isS(tx + 1, ty) });
        } else if (t === ONEWAY) G.drawOneway(g, w, px, py, tx, { l: this.tile(tx - 1, ty) === ONEWAY || isS(tx - 1, ty), r: this.tile(tx + 1, ty) === ONEWAY || isS(tx + 1, ty) });
        else if (t === SPIKE_U) G.drawSpikes(g, px, py, false);
        else if (t === SPIKE_D) G.drawSpikes(g, px, py, true);
      }
      // decor sits in the empty cell above exposed ground
      for (let ty = 1; ty < this.h; ty++) for (let tx = 0; tx < this.w; tx++) {
        if (this.tiles[ty * this.w + tx] === SOLID && this.tiles[(ty - 1) * this.w + tx] === E && !this.reserved(tx, ty - 1)) G.drawDecor(g, w, tx * T, (ty - 1) * T, tx, ty);
      }
    }
    reserved(tx, ty) {
      const ch = (this.def.map[ty] || '')[tx];
      return ch && ch !== ' ' && ch !== '.';
    }

    // ---------- effects ----------
    shake(a) { this.trauma = Math.min(1, this.trauma + a); }
    stop(t) { this.hitstop = Math.max(this.hitstop, t); }
    flashScreen(a, col) { this.flash = a; this.flashCol = col || '#ffffff'; }
    part(x, y, vx, vy, life, size, col, grav, o) {
      if (this.fx.length > 700) return null;
      const p = { k: 0, x, y, vx, vy, life, max: life, size, col, g: grav || 0, drag: 0, glow: 0 };
      if (o) Object.assign(p, o);
      this.fx.push(p);
      return p;
    }
    burst(x, y, n, cols, spd, grav, o) {
      for (let i = 0; i < n; i++) {
        const a = Math.random() * Math.PI * 2, s = spd * (0.3 + Math.random() * 0.8);
        this.part(x, y, Math.cos(a) * s, Math.sin(a) * s - spd * 0.3, 0.3 + Math.random() * 0.45, 1 + (Math.random() * 2.2 | 0), Array.isArray(cols) ? G.pick(cols) : cols, grav === undefined ? 300 : grav, o);
      }
    }
    dust(x, y, n, dir) {
      for (let i = 0; i < n; i++) this.part(x + G.rand(-3, 3), y - 1, (dir || G.rand(-1, 1)) * G.rand(10, 40) + G.rand(-12, 12), G.rand(-28, -6), G.rand(0.2, 0.42), 1 + (Math.random() * 2 | 0), i % 2 ? '#e8e0f0' : this.th.fx, -40, { drag: 3 });
    }
    ring(x, y, r0, r1, col, life) { this.fx.push({ k: 1, x, y, r0, r1, col, life, max: life, vx: 0, vy: 0, g: 0 }); }
    pop(x, y, text, col, big) { this.fx.push({ k: 2, x, y, text, col: col || '#fff', life: big ? 1.3 : 0.8, max: big ? 1.3 : 0.8, vx: 0, vy: -26, g: 0, big }); }
    spark(x, y, col, n) { for (let i = 0; i < (n || 5); i++) { const a = Math.random() * 6.28, s = G.rand(60, 160); this.part(x, y, Math.cos(a) * s, Math.sin(a) * s, G.rand(0.12, 0.25), 1, col || '#fff', 0, { drag: 5, glow: 1 }); } }
    explode(x, y, size, cols) {
      cols = cols || ['#fff', '#ffe27a', '#ff9a3a', '#ff5d5d'];
      this.ring(x, y, 2, size, '#fff', 0.25);
      this.burst(x, y, Math.round(size * 0.8), cols, size * 5, 120, { glow: 1 });
      for (let i = 0; i < size / 4; i++) this.part(x + G.rand(-size, size) * 0.4, y + G.rand(-size, size) * 0.4, G.rand(-20, 20), G.rand(-50, -10), G.rand(0.4, 0.8), 3, '#6b6478', -30, { drag: 2 });
      this.fx.push({ k: 3, x, y, r: size * 0.6, life: 0.14, max: 0.14, col: '#fff', vx: 0, vy: 0, g: 0 });
    }
    // hostile projectile. kinds: orb, log, shard, drip, bolt, wave, plus, minus
    shoot(x, y, vx, vy, o) {
      const p = Object.assign({ x, y, vx, vy, r: 3, kind: 'orb', col: C.hazard, life: 4, g: 0, dmg: 1, tile: true, cut: true, t: 0 }, o);
      this.projs.push(p);
      return p;
    }
    drop(x, y, n, kind) {
      for (let i = 0; i < n; i++) this.items.push({ kind: kind || 'token', x, y, vx: G.rand(-70, 70), vy: G.rand(-190, -90), loose: true, t: 0, ph: i });
    }

    // ---------- camera ----------
    camTarget() {
      const p = this.player;
      let tx = p.x + p.w / 2 - W / 2 + this.cam.look, ty = this.cam.ty;
      if (this.cam.lock) { tx = this.cam.lock.x; ty = this.cam.lock.y; }
      if (this.pw <= W) tx = (this.pw - W) / 2; else tx = G.clamp(tx, 0, this.pw - W);
      if (this.ph <= H) ty = this.ph - H; else ty = G.clamp(ty, 0, this.ph - H);
      return [tx, ty];
    }
    snapCam() {
      const p = this.player;
      this.cam.ty = p.y + p.h - H * 0.64;
      const [tx, ty] = this.camTarget();
      this.cam.x = tx; this.cam.y = ty;
    }
    updateCam(dt) {
      const p = this.player, c = this.cam;
      c.look = G.damp(c.look, p.face * 22 + G.clamp(p.vx * 0.12, -16, 16), 2.2, dt);
      const feet = p.y + p.h;
      if (p.onGround || p.wallDir) c.ty = G.damp(c.ty, feet - H * 0.64, 5, dt);
      const sy = feet - c.ty;                         // feet in screen space if camera were at target
      if (sy < 56) c.ty = feet - 56; else if (sy > H - 44) c.ty = feet - (H - 44);
      const [tx, ty] = this.camTarget();
      c.x = G.damp(c.x, tx, 8, dt);
      c.y = G.damp(c.y, ty, Math.abs(ty - c.y) > 60 ? 9 : 5, dt);
    }

    // ---------- update ----------
    update(dt) {
      this.trauma = Math.max(0, this.trauma - dt * 2.2);
      if (this.flash > 0) this.flash = Math.max(0, this.flash - dt * 3);
      if (this.hitstop > 0) { this.hitstop -= dt; return; }
      this.time += dt;
      const p = this.player;
      if (!p.dead && !this.frozen) this.clock += dt;

      // blinking blocks
      const ph = Math.floor(this.time / this.blinkPeriod) % 2;
      if (ph !== this.blinkPhase) {
        this.blinkPhase = ph;
        if (this.hasBlink === undefined) this.hasBlink = this.tiles.includes(BLINK_A) || this.tiles.includes(BLINK_B);
        if (this.hasBlink) {
          const want = ph === 0 ? BLINK_A : BLINK_B;
          const x0 = Math.floor(p.x / T), x1 = Math.floor((p.x + p.w) / T), y0 = Math.floor(p.y / T), y1 = Math.floor((p.y + p.h) / T);
          for (let ty = y0; ty <= y1; ty++) for (let tx = x0; tx <= x1; tx++) if (this.tile(tx, ty) === want) this.blinkHold.add(ty * this.w + tx);
          if (Math.abs(p.x - this.cam.x - W / 2) < W) G.audio.sfx(ph ? 'tock' : 'tick');
        }
      }
      if (this.blinkHold.size) for (const i of this.blinkHold) {
        const tx = i % this.w, ty = (i / this.w) | 0;
        if (!(p.x < tx * T + T && p.x + p.w > tx * T && p.y < ty * T + T && p.y + p.h > ty * T)) this.blinkHold.delete(i);
      }
      // crumbling blocks
      for (const [i, c] of this.crumble) {
        c.t -= dt;
        if (c.t > 0) continue;
        const tx = i % this.w, ty = (i / this.w) | 0;
        if (c.s === 1) { c.s = 2; c.t = 2.6; this.burst(tx * T + 8, ty * T + 4, 7, ['#cbb894', '#8a7a5c'], 50, 260); G.audio.sfx('crumble'); }
        else if (c.s === 2) {
          if (p.x < tx * T + T && p.x + p.w > tx * T && p.y < ty * T + T && p.y + p.h > ty * T) c.t = 0.2;
          else { this.crumble.delete(i); this.dust(tx * T + 8, ty * T + 8, 4); }
        }
      }
      if (this.breakQ.length) { for (const q of this.breakQ) { q.t -= dt; if (q.t <= 0) { q.done = true; this.breakTile(q.tx, q.ty); } } this.breakQ = this.breakQ.filter((q) => !q.done); }
      // moving platforms
      for (const m of this.plats) {
        const span = Math.abs(m.b - m.a);
        if (span < 1) { m.dx = m.dy = 0; continue; }
        const period = (span / m.speed) * 2;
        const u = 0.5 - 0.5 * Math.cos(((this.time / period + m.ph) % 1) * Math.PI * 2);
        const v = G.lerp(m.a, m.b, u);
        if (m.ax) { m.dx = v - m.x; m.dy = 0; m.x = v; } else { m.dy = v + 2 - m.y; m.dx = 0; m.y = v + 2; }
      }
      // rising liquid
      if (this.rise) {
        if (!this.rising && p.y < this.rise.trigger * T) { this.rising = true; G.audio.sfx('roar'); this.shake(0.5); }
        if (this.rising && !p.dead && !this.frozen) {
          const gap = this.liquidY - (p.y + p.h);
          this.liquidY -= (this.rise.speed + Math.max(0, gap - 130) * 1.2) * dt;
          this.liquidY = Math.max(this.liquidY, (this.rise.top || 0) * T);
        }
      }

      p.update(dt);

      // creatures
      const cx = this.cam.x, cy = this.cam.y;
      for (const e of this.ents) {
        if (e.dead) continue;
        if (e.always || (e.x + e.w > cx - 90 && e.x < cx + W + 90 && e.y + e.h > cy - 110 && e.y < cy + H + 110)) e.update(dt);
        else if (e.asleep) e.asleep(dt);
      }
      this.interact(dt);
      this.updateItems(dt);
      this.updateProjs(dt);
      for (const s of this.springs) if (s.t > 0) s.t -= dt;

      // particles
      const fx = this.fx;
      for (let i = fx.length - 1; i >= 0; i--) {
        const q = fx[i];
        q.life -= dt;
        if (q.life <= 0) { fx[i] = fx[fx.length - 1]; fx.pop(); continue; }
        if (q.k === 0 || q.k === 2) {
          q.vy += q.g * dt;
          if (q.drag) { const d = Math.exp(-q.drag * dt); q.vx *= d; q.vy *= d; }
          q.x += q.vx * dt; q.y += q.vy * dt;
          if (q.bounce && q.vy > 0 && this.solidAt(q.x, q.y + 1)) { q.vy *= -0.45; q.vx *= 0.7; q.y -= 1; }
        }
      }
      // tidy
      if (this.ents.some((e) => e.dead && !e.keep)) this.ents = this.ents.filter((e) => !e.dead || e.keep);
      if (!this.cam.frozen) this.updateCam(dt);
    }

    interact() {
      const p = this.player;
      if (p.dead || p.gone) return;
      // claw
      if (p.atkT > 0 && p.atkLive) {
        const box = p.atkBox();
        for (const e of this.ents) {
          if (e.dead || e.hitId === p.atkId || e.noHit) continue;
          for (const b of e.hurtboxes()) {
            if (!G.overlap(box, b)) continue;
            e.hitId = p.atkId;
            const res = e.hit(p.atkDmg, p.atkDir === 'f' ? p.atkFace : 0, p.atkDir === 'u' ? -1 : p.atkDir === 'd' ? 1 : 0, 'swipe', b);
            if (res) p.onHit(e, res, b);
            break;
          }
        }
        for (const q of this.projs) {
          if (q.dead || !q.cut || q.friendly) continue;
          if (q.x + q.r > box.x && q.x - q.r < box.x + box.w && q.y + q.r > box.y && q.y - q.r < box.y + box.h) {
            q.dead = true; this.spark(q.x, q.y, q.col, 6); G.audio.sfx('clang'); this.stop(0.03);
            if (p.atkDir === 'd') p.bounce(0.85);
          }
        }
        for (const s of this.springs) if (p.atkDir === 'd' && G.overlap(box, s)) p.spring(s);
      }
      // touching
      const hb = p.hurtbox();
      for (const e of this.ents) {
        if (e.dead || e.passive) continue;
        for (const b of e.harmboxes()) {
          if (!G.overlap(hb, b)) continue;
          if (p.dashT > 0 && e.dashable !== false) {
            if (e.dashId !== p.dashId) { e.dashId = p.dashId; const res = e.hit(1, p.dashDx || p.face, 0, 'dash', b); if (res) { this.stop(0.05); this.shake(0.2); } }
          } else if (e.stompable && p.vy > 30 && p.prevBottom <= b.y + Math.min(8, b.h * 0.6)) {
            const res = e.hit(1, 0, 1, 'stomp', b);
            p.y = b.y - p.h; p.bounce(1);
            if (res) { this.stop(0.05); }
          } else if (p.grace <= 0) p.hurt(e.dmg || 1, b.x + b.w / 2);
          break;
        }
      }
      // spikes, liquid, pits
      if (p.inv <= 0 || true) {
        const x0 = Math.floor((p.x + 1) / T), x1 = Math.floor((p.x + p.w - 1) / T), y0 = Math.floor((p.y + 1) / T), y1 = Math.floor((p.y + p.h - 1) / T);
        let hz = false;
        for (let ty = y0; ty <= y1 && !hz; ty++) for (let tx = x0; tx <= x1; tx++) {
          const t = this.tile(tx, ty);
          if (t === SPIKE_U) { if (p.y + p.h > ty * T + 9 && p.x + p.w > tx * T + 2 && p.x < tx * T + 14) hz = true; }
          else if (t === SPIKE_D) { if (p.y < ty * T + 7 && p.x + p.w > tx * T + 2 && p.x < tx * T + 14) hz = true; }
          else if (t === LIQ) { if (p.y + p.h > ty * T + 6) hz = 'liq'; }
        }
        if (this.liquidY !== null && p.y + p.h > this.liquidY + 5) hz = 'liq';
        if (p.y > this.ph + 24) hz = 'pit';
        if (hz) { if (hz === 'liq') { this.burst(p.x + 5, p.y + 8, 12, [this.th.liq, this.th.liqHi], 110, 300); G.audio.sfx('splash'); } p.hazard(); }
      }
      // springs
      for (const s of this.springs) if (p.vy >= 0 && G.overlap(hb, s) && p.dashT <= 0) p.spring(s);
      // checkpoints + exit + signs
      this.cps.forEach((c, i) => {
        if (!c.on && Math.abs(p.x + p.w / 2 - c.x) < 12 && p.y + p.h > c.y - 34 && p.y < c.y) {
          for (const o of this.cps) o.on = false;
          c.on = true; this.cpIndex = i; p.hp = Math.max(p.hp, p.maxHp); p.setSafe(c.x - 5, c.y - p.h);
          this.ring(c.x, c.y - 22, 3, 26, C.ok, 0.4); this.burst(c.x, c.y - 22, 14, [C.ok, C.okHi, '#fff'], 100, 100, { glow: 1 });
          this.pop(c.x, c.y - 36, 'committed ✓', C.okHi, true);
          G.audio.sfx('checkpoint');
          this.events.push('checkpoint');
        }
      });
      if (this.exit && !this.exit.done && Math.abs(p.x + p.w / 2 - this.exit.x) < 10 && Math.abs(p.y + p.h - this.exit.y) < 20 && p.onGround) {
        this.exit.done = true; this.events.push('exit');
      }
      this.sign = null;
      for (const s of this.signs) if (Math.abs(p.x + p.w / 2 - s.x) < 26 && Math.abs(p.y + p.h - s.y) < 30) this.sign = s;
    }

    updateItems(dt) {
      const p = this.player, pcx = p.x + p.w / 2, pcy = p.y + p.h / 2;
      for (const it of this.items) {
        if (it.dead) continue;
        if (it.loose) {
          it.t += dt;
          if (it.t > 0.35 && !p.dead) {            // drawn to the hero
            const dx = pcx - it.x, dy = pcy - it.y, d = Math.hypot(dx, dy) || 1, pull = Math.min(700, 160 + it.t * 500);
            it.vx = G.damp(it.vx, (dx / d) * pull, 8, dt); it.vy = G.damp(it.vy, (dy / d) * pull, 8, dt);
          } else {
            it.vy += 520 * dt;
            if (it.vy > 0 && this.solidAt(it.x, it.y + 4)) { it.vy *= -0.5; it.vx *= 0.7; }
          }
          it.x += it.vx * dt; it.y += it.vy * dt;
          if (it.t > 8) it.dead = true;
        }
        const r = it.kind === 'spark' ? 11 : 9;
        if (!p.dead && !p.gone && Math.abs(pcx - it.x) < r + 3 && Math.abs(pcy - it.y) < r && (!it.loose || it.t > 0.2)) this.collect(it);
      }
      if (this.items.length > 40 && this.items.some((i) => i.dead)) this.items = this.items.filter((i) => !i.dead);
    }
    collect(it) {
      const p = this.player;
      it.dead = true;
      if (it.id !== undefined) this.got.add(it.id);
      if (it.kind === 'token') {
        this.tokens++; p.addMeter(it.loose ? 2 : 3);
        this.spark(it.x, it.y, C.goldHi, 4); G.audio.sfx('token');
        // every 25 tokens buys back a pip
        if (this.tokens % 25 === 0 && p.hp < p.maxHp) { p.hp++; this.pop(p.x + 5, p.y - 12, '25 coins: +1', C.goldHi, true); G.audio.sfx('heal'); }
      } else if (it.kind === 'spark') {
        this.sparks[it.idx] = true;
        this.ring(it.x, it.y, 2, 30, C.leafHi, 0.5); this.burst(it.x, it.y, 18, [C.leafMid, C.leaf, C.leafHi], 130, 60, { glow: 1 });
        this.pop(it.x, it.y - 12, it.ghost ? 'leaf' : '❦ leaf found!', '#fff3e4', true);
        this.stop(0.07); G.audio.sfx('spark'); p.addMeter(25);
        this.events.push('spark');
      } else if (it.kind === 'coffee') {
        if (p.hp < p.maxHp) p.hp++;
        this.pop(it.x, it.y - 10, '+1 coffee', C.paper); this.burst(it.x, it.y, 8, [C.paper, C.accent], 70, 100);
        G.audio.sfx('heal');
      }
    }
    updateProjs(dt) {
      const p = this.player, hb = p.hurtbox();
      for (const q of this.projs) {
        if (q.dead) continue;
        q.t += dt; q.life -= dt;
        q.vy += q.g * dt;
        q.x += q.vx * dt; q.y += q.vy * dt;
        if (q.update) q.update(q, dt, this);
        if (q.life <= 0 || q.y > this.ph + 60 || q.x < -60 || q.x > this.pw + 60) { q.dead = true; continue; }
        if (q.tile && this.solidAt(q.x, q.y)) {
          q.dead = true;
          if (q.onLand) q.onLand(q, this); else this.spark(q.x, q.y, q.col, 4);
          continue;
        }
        if (this.liquidY !== null && q.y > this.liquidY + 3 && q.kind === 'drip') { q.dead = true; continue; }
        if (!q.friendly && !p.dead && !p.gone && q.x + q.r > hb.x && q.x - q.r < hb.x + hb.w && q.y + q.r > hb.y && q.y - q.r < hb.y + hb.h) {
          if (p.dashT > 0) continue;
          if (p.hurt(q.dmg, q.x) && !q.pierce) { q.dead = true; this.spark(q.x, q.y, q.col, 5); }
        }
      }
      if (this.projs.length > 30 && this.projs.some((q) => q.dead)) this.projs = this.projs.filter((q) => !q.dead);
    }

    // ---------- draw ----------
    draw(g) {
      const amp = this.trauma * this.trauma * 7 * G.save.data.opt.shake;
      const cx = Math.round(this.cam.x + (Math.random() * 2 - 1) * amp), cy = Math.round(this.cam.y + (Math.random() * 2 - 1) * amp);
      this.cx = cx; this.cy = cy;
      const t = this.time, p = this.player, w = this.world;
      G.ambient = this.def.ambient || this.th.ambient;
      G.drawBG(w, g, cx, cy, G.time, Math.max(0, this.ph - H));
      g.drawImage(this.layer, -cx, -cy);

      // dynamic tiles
      const tx0 = Math.max(0, Math.floor(cx / T)), tx1 = Math.min(this.w - 1, Math.floor((cx + W) / T));
      const ty0 = Math.max(0, Math.floor(cy / T)), ty1 = Math.min(this.h - 1, Math.floor((cy + H) / T));
      const untilSwitch = this.blinkPeriod - (this.time % this.blinkPeriod);
      for (let ty = ty0; ty <= ty1; ty++) for (let tx = tx0; tx <= tx1; tx++) {
        const i = ty * this.w + tx, tt = this.tiles[i];
        if (tt < CRACK) {
          if (w === 5 && tt === SOLID) { const hh = G.hash(tx, ty, 91); if (hh < 0.22 && Math.sin(t * (2 + hh * 30) + hh * 80) > 0.2) { g.fillStyle = hh < 0.07 ? '#ff4b3e' : hh < 0.14 ? '#f2c14e' : '#7fd08a'; g.fillRect(tx * T - cx + 4 + ((hh * 97) | 0) % 8, ty * T - cy + 4, 1, 1); } }
          continue;
        }
        const px = tx * T - cx, py = ty * T - cy;
        if (tt === CRACK) g.drawImage(S.cracked, px, py);
        else if (tt === CRUMBLE) {
          const c = this.crumble.get(i);
          if (!c) g.drawImage(S.crumble, px, py);
          else if (c.s === 1) g.drawImage(S.crumble, px + ((Math.random() * 3) | 0) - 1, py + ((Math.random() * 2) | 0));
          else if (c.t < 0.5 && ((c.t * 16) | 0) % 2) { g.globalAlpha = 0.4; g.drawImage(S.crumble, px, py); g.globalAlpha = 1; }
        } else if (tt === BLINK_A || tt === BLINK_B) {
          const k = tt === BLINK_A ? 0 : 1, on = this.blinkPhase === k && !this.blinkHold.has(i);
          const warn = untilSwitch < 0.42 && ((untilSwitch * 14) | 0) % 2;
          g.drawImage(on ? (warn ? S.blink[k].off : S.blink[k].on) : (warn ? S.blink[k].on : S.blink[k].off), px, py);
          if (!on && warn) { g.globalAlpha = 0.35; g.fillStyle = '#0d0a12'; g.fillRect(px, py, T, T); g.globalAlpha = 1; }
        }
      }
      // platforms
      const ps = G.platformSprite(w);
      for (const m of this.plats) { g.drawImage(ps, Math.round(m.x) - cx, Math.round(m.y) - cy - 1); G.light(m.x + 24 - cx, m.y + 8 - cy, 22, this.th.accent, 0.3, 0.12); }
      // furniture
      for (const c of this.cps) {
        g.drawImage(S.checkpoint[c.on ? 1 : 0], c.x - 8 - cx, c.y - 28 - cy);
        if (c.on) G.light(c.x - cx, c.y - 22 - cy, 34, C.ok, 0.8, 0.3);
      }
      for (const s of this.signs) g.drawImage(S.sign, s.x - 8 - cx, s.y - 18 - cy);
      for (const s of this.springs) g.drawImage(S.spring[s.t > 0 ? 0 : 1], s.x - 2 - cx, s.y - 7 - cy + (s.t > 0 ? 0 : 0));
      if (this.exit) this.drawGate(g, this.exit.x - cx, this.exit.y - cy, t);
      // pickups
      for (const it of this.items) {
        if (it.dead) continue;
        const bob = it.loose ? 0 : Math.round(Math.sin(t * 3 + it.ph) * 1.5), x = Math.round(it.x) - cx, y = Math.round(it.y) - cy + bob;
        if (x < -12 || x > W + 12 || y < -12 || y > H + 12) continue;
        if (it.kind === 'token') g.drawImage(S.token[((t * 7 + it.ph * 2) | 0) % 4], x - 4, y - 4);
        else if (it.kind === 'spark') {
          const f = ((t * 3) | 0) % 2;
          g.drawImage((it.ghost ? S.leafGhost : S.leaf)[f], x - 7, y - 7);
          if (!it.ghost) { G.light(x, y, 34, '#d4ff9a', 0.9, 0.42); if (Math.random() < 0.08) this.part(it.x + G.rand(-6, 6), it.y + G.rand(-6, 6), 0, -14, 0.5, 1, C.leafHi, 0, { glow: 1 }); }
        } else if (it.kind === 'coffee') { g.drawImage(S.coffee, x - 6, y - 7); G.light(x, y, 20, '#fff', 0.5, 0.12); }
      }
      // creatures (those drawn behind the hero)
      for (const e of this.ents) if (!e.dead && !e.front) e.draw(g, cx, cy);
      if (this.others) this.others(g, cx, cy);        // friends running the same stage (client/1-endpoints/net/presence.ts): drawn behind the hero, no collision
      p.draw(g, cx, cy);
      for (const e of this.ents) if (!e.dead && e.front) e.draw(g, cx, cy);
      // projectiles
      for (const q of this.projs) if (!q.dead) this.drawProj(g, q, cx, cy);
      // particles
      for (const q of this.fx) {
        const x = Math.round(q.x) - cx, y = Math.round(q.y) - cy, u = q.life / q.max;
        if (q.k === 0) {
          const s = Math.max(1, Math.ceil(q.size * (q.keep ? 1 : Math.min(1, u * 1.6))));
          g.fillStyle = q.col; g.fillRect(x - (s >> 1), y - (s >> 1), s, s);
          if (q.glow) G.light(x, y, 5 + s * 3, q.col, 0.35 * u, 0.3 * u);
        } else if (q.k === 1) G.ring(g, x, y, G.lerp(q.r0, q.r1, G.ease.out(1 - u)), q.col);
        else if (q.k === 2) G.text(G.ug, q.text, x, y, q.col, { align: 'c', outline: '#1b1226', tiny: !q.big });
        else if (q.k === 3) { G.disc(g, x, y, q.r * (0.6 + 0.4 * u), q.col); G.light(x, y, q.r * 4, '#fff', 1, 0.6); }
      }
      // liquid goes over everything
      for (let tx = tx0; tx <= tx1; tx++) {
        let top = -1;
        for (let ty = ty0; ty <= ty1 + 1; ty++) {
          const isL = ty <= ty1 && this.tiles[ty * this.w + tx] === LIQ;
          if (isL && top < 0) top = ty;
          if (!isL && top >= 0) {
            const surface = top > 0 && this.tiles[(top - 1) * this.w + tx] !== LIQ;
            const px = tx * T - cx, y0 = top * T - cy + (surface ? 4 : 0), y1 = ty * T - cy;
            if (surface) G.drawLiquid(g, w, px, y0, px + T, y1, t, cx);
            else { g.fillStyle = G.rgba(this.th.liq, 0.5); g.fillRect(px, y0, T, y1 - y0); g.fillStyle = G.rgba(this.th.liqLo, 0.45); g.fillRect(px, y0, T, y1 - y0); }
            if (surface && (tx & 1)) G.light(px + 8, y0 + 4, 30, this.th.liq, 0.55, 0.16);
            top = -1;
          }
        }
      }
      if (this.liquidY !== null && this.liquidY - cy < H + 4) {
        G.drawLiquid(g, w, 0, this.liquidY - cy, W, H + 4, t, cx);
        for (let x = 20; x < W; x += 60) G.light(x, this.liquidY - cy + 4, 46, this.th.liq, 0.7, 0.2);
      }
      if (this.flash > 0) { g.globalAlpha = Math.min(1, this.flash); g.fillStyle = this.flashCol; g.fillRect(0, 0, W, H); g.globalAlpha = 1; G.light(W / 2, H / 2, 400, '#fff', this.flash, 0); }
    }
    drawGate(g, x, y, t) {
      g.drawImage(S.gate, x - 15, y - 40);
      const sx = x - 11, sy = y - 30;
      g.fillStyle = '#7dff9a';
      // scrolling "tests"
      for (let i = 0; i < 6; i++) {
        const yy = sy + ((i * 5 + Math.floor(t * 9)) % 28), len = 4 + ((i * 7) % 11);
        g.globalAlpha = 0.25 + 0.12 * (i % 3); g.fillRect(sx + 1 + (i % 2) * 3, yy, len, 1);
      }
      g.globalAlpha = 1;
      G.text(g, '>', x - 8, y - 23, '#7dff9a');
      if (((t * 2.5) | 0) % 2) { g.fillStyle = '#d6ffd0'; g.fillRect(x - 1, y - 23, 4, 7); }
      G.light(x, y - 18, 56, '#7dff9a', 0.9, 0.32);
      if (Math.random() < 0.12) this.part(x + this.cx + G.rand(-10, 10), y + this.cy - 2, 0, G.rand(-30, -14), 0.8, 1, '#7dff9a', 0, { glow: 1 });
    }
    drawProj(g, q, cx, cy) {
      const x = Math.round(q.x) - cx, y = Math.round(q.y) - cy, r = q.r;
      if (x < -20 || x > W + 20 || y < -20 || y > H + 20) return;
      switch (q.kind) {
        case 'log': g.fillStyle = K0; g.fillRect(x - 5, y - 2, 10, 4); g.fillStyle = q.col; g.fillRect(x - 4, y - 1, 5, 2); g.fillStyle = '#fff'; g.fillRect(x + 2, y - 1, 2, 2); break;
        case 'shard': case 'plus': case 'minus': {
          g.fillStyle = K0; g.fillRect(x - 3, y - 1 - (q.kind === 'minus' ? 0 : 2), 7, q.kind === 'minus' ? 3 : 7);
          if (q.kind !== 'minus') g.fillRect(x - 3, y - 1, 7, 3);
          g.fillStyle = q.col; g.fillRect(x - 2, y, 5, 1); if (q.kind !== 'minus') g.fillRect(x, y - 2, 1, 5);
          break;
        }
        case 'drip': g.fillStyle = q.col; g.fillRect(x - 1, y - 2, 2, 4); g.fillRect(x - 2, y, 4, 2); g.fillStyle = '#fff'; g.fillRect(x - 1, y, 1, 1); break;
        case 'bolt': {
          const a = Math.atan2(q.vy, q.vx), dx = Math.cos(a), dy = Math.sin(a);
          for (let i = 0; i < 5; i++) { g.fillStyle = i < 2 ? '#fff' : q.col; g.fillRect(Math.round(x - dx * i * 2) - 1, Math.round(y - dy * i * 2) - 1, i < 3 ? 3 : 2, i < 3 ? 3 : 2); }
          break;
        }
        case 'wave': {
          const hgt = q.hgt || 10;
          g.fillStyle = q.col; g.fillRect(x - 3, y - hgt, 6, hgt); g.fillStyle = '#fff'; g.fillRect(x - 1, y - hgt, 2, hgt - 2); g.fillStyle = K0; g.fillRect(x - 4, y - hgt + 2, 1, hgt - 2); g.fillRect(x + 3, y - hgt + 2, 1, hgt - 2);
          break;
        }
        default: G.disc(g, x, y, r + 1, K0); G.disc(g, x, y, r, q.col); G.disc(g, x - 1, y - 1, Math.max(0.5, r - 2), '#fff');
      }
      G.light(x, y, 18 + r * 3, q.col, 0.6, 0.3);
    }
  }
  const K0 = '#1b1226';
  G.Level = Level;
})();

